<div *ngIf="icon">
  <rt-icon size="large-x" [name]="icon"></rt-icon>
</div>

<div
  *ngIf="imageUrl"
  [class.img-fixed-dimensions]="!!fixedImageDimensions"
  [ngStyle]="{
    width: fixedImageDimensions?.width ? fixedImageDimensions?.width : 'auto',
    height: fixedImageDimensions?.height ? fixedImageDimensions?.height : 'auto'
  }"
>
  <img src="{{ imageUrl }}" />
</div>

<div *ngIf="title" class="heading" [class.with-icon]="titleIcon">
  <rt-icon *ngIf="titleIcon" [name]="titleIcon" size="large"></rt-icon>
  {{ title }}
</div>

<div *ngIf="desc" class="subheading" [innerHTML]="desc"></div>

<div class="content">
  <ng-content></ng-content>
</div>
